<template>
    <el-form
        v-loading="loading"
        label-position="left"
        ref="form"
        :model="model"
        label-width="242px"
    >
        <div class="edit__actions">
            <el-button type="secondary" @click="onBack" class="btn-back"
                >Back to overview</el-button
            >
            <div>
                <el-button
                    type="primary"
                    @click="onDownloadExcel"
                    v-if="isOrderDetail()"
                    >Download as XLS</el-button
                >
                <el-button
                    type="primary"
                    @click="onPrint"
                    v-if="isOrderDetail()"
                    >Print</el-button
                >
            </div>
        </div>

        <el-tabs v-model="activeTab">
            <el-tab-pane
                :key="tab.label"
                v-for="tab in config.formFields"
                :label="tab.label"
            >
                <div
                    :siteId="siteId"
                    :permitted-sites-config="permittedSitesConfig"
                    :model="model"
                    :config="item"
                    :root-config="rootConfig"
                    :is="item.component"
                    :options="item.options"
                    v-for="item in tab.body"
                    :key="item._uid"
                ></div>

                <el-form-item
                    :key="field.name"
                    :label="field.label"
                    v-for="field in tab.fields"
                >
                    <div
                        :placeholder="field.placeholder"
                        :root-config="rootConfig"
                        :options="field.options"
                        :type="field.type"
                        :is="field.component"
                        :root-model="model"
                        v-model="model[field.name]"
                    ></div>
                </el-form-item>
            </el-tab-pane>
        </el-tabs>

        <el-form-item v-if="!config.hideActionBar">
            <el-button type="primary" @click="onSubmit">Save</el-button>
            <el-button
                @click="
                    $router.push({
                        name: 'admin',
                        params: { id: 'all', action: 'index' },
                    })
                "
                >Cancel</el-button
            >
        </el-form-item>
    </el-form>
</template>

<script>
import api from '../libs/api';
import download from '../libs/download';

export default {
    name: 'v-crud-edit',

    props: ['config', 'rootConfig', 'params', 'id', 'siteId', 'permittedSitesConfig'],

    data() {
        return {
            model: {},
            activeTab: '0',
            loading: false,
        };
    },

    watch: {
        '$route.params.model'() {
            this.loadData();
        },
    },

    mounted() {
        this.loadData();
    },

    methods: {
        loadData() {
            this.loading = true;
            api.res
                .get({ id: this.id })
                .then(this.setModelData)
                .catch(api.errorHandler);
        },

        onSubmit() {
            let params = {};

            if (this.config.singleRootObject) {
                params[this.config.singleRootObject] = this.model;
            } else {
                params = this.model;
            }

            params = this.handleAttachments(params);

            api.res
                .update({ id: this.id }, params)
                .then(() => {
                    this.$router.push({
                        name: 'admin',
                        params: { id: 'all', action: 'index' },
                    });
                })
                .catch(api.errorHandler);
        },

        handleAttachments(params) {
            if (params.hasOwnProperty('attachments')) {
                // if there are attachments, split the lines to an array
                if (params.attachments.length > 0) {
                    params.attachments = params.attachments.split('\n');
                } else {
                    // otherwise send an empty array
                    params.attachments = [];
                }
            }

            return params;
        },

        setModelData(res) {
            if (this.config.singleRootObject) {
                this.model = res.body[this.config.singleRootObject];
            } else {
                if (res.body.hasOwnProperty('attachments')) {
                    res.body.attachments = res.body.attachments.join('\n');
                }
                this.model = res.body;
            }
            this.loading = false;
            this.activeTab = '0';
        },

        onBack() {
            this.$router.back();
        },

        isOrderDetail() {
            return this.$route.params.model === 'orders';
        },

        onPrint() {
            // TODO: After Logout/Session Bug is fixed:
            // const routeData = this.$router.resolve({
            //     name: 'admin',
            //     params: {
            //         model: this.$route.params.model,
            //         id: this.$route.params.id,
            //         action: 'print',
            //     },
            // });
            // window.open(routeData.href, '_blank');

            this.$router.push({
                name: 'admin',
                params: {
                    action: 'print',
                },
            });
        },

        onDownloadExcel() {
            const url = `${this.rootConfig.endPoint}/orders/${this.id}?as_excel=true`;
            this.$http.get(url, { responseType: 'blob' }).then(
                (res) => {
                    download(res.data, 'order.xls', 'application/vnd.ms-excel');
                },
                (err) => {
                    console.error(err);
                    api.errorHandler.call(this, err);
                }
            );
        },
    },
};
</script>
<style>
.edit__actions {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.btn-back {
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// VueCrudEdit.vue?dbf0c8ae